import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.news');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import showdown from 'showdown';

type LocalText = { ko: string; en: string };
type NewsCategory = { key: string; label: LocalText; icon: string };
type NewsGroup = { year: string; items: any[] };

@Component({
    selector: 'wiz-page-news',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.news/view.scss */
:host {
  display: block;
  background: #FFFFFF;
}

:host *,
:host *::before,
:host *::after {
  animation: none !important;
  transition: none !important;
  scroll-behavior: auto !important;
}

.news-page {
  min-height: 60vh;
  background: #FFFFFF;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.news-page h1,
.news-page h2,
.news-page h3,
.news-page h4,
.news-page p,
.news-page span,
.news-page button {
  letter-spacing: 0;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.section-eyebrow {
  margin: 0 0 14px;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.news-hero {
  position: relative;
  min-height: 380px;
  display: flex;
  align-items: center;
  overflow: hidden;
  color: #FFFFFF;
  background: #11100F;
}

.news-hero-bg,
.news-hero-grid {
  position: absolute;
  inset: 0;
}

.news-hero-bg {
  background: radial-gradient(circle at 82% 18%, rgba(254, 90, 51, 0.26), transparent 34%), linear-gradient(135deg, #0C0A09 0%, #181413 58%, #251815 100%);
}

.news-hero-grid {
  opacity: 0.38;
  background-image: linear-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0.22), #000 34%, #000 78%, rgba(0, 0, 0, 0.18));
  -webkit-mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0.22), #000 34%, #000 78%, rgba(0, 0, 0, 0.18));
}

.news-hero-inner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 410px;
  align-items: center;
  gap: 56px;
  padding: 64px 0 58px;
}

.news-hero-copy {
  max-width: 720px;
}
.news-hero-copy h1 {
  margin: 0;
  font-size: 44px;
  line-height: 1.16;
  font-weight: 800;
}
.news-hero-copy p {
  margin: 18px 0 0;
  max-width: 660px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  line-height: 1.75;
}

.news-kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  font-weight: 700;
}

.news-kicker-mark {
  width: 30px;
  height: 2px;
  border-radius: 1px;
  background: #FE5A33;
}

.news-summary {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(12, 10, 9, 0.58);
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.26);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  overflow: hidden;
}

.summary-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.summary-head span {
  color: rgba(255, 255, 255, 0.52);
  font-size: 16px;
  font-weight: 700;
}
.summary-head strong {
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 800;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.summary-item {
  min-height: 102px;
  padding: 20px;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.summary-item:nth-child(2n) {
  border-right: 0;
}
.summary-item:nth-last-child(-n+2) {
  border-bottom: 0;
}

.summary-value {
  display: block;
  color: #FFFFFF;
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
  word-break: keep-all;
  overflow-wrap: normal;
}

.summary-label {
  display: block;
  margin-top: 9px;
  color: rgba(255, 255, 255, 0.56);
  font-size: 16px;
  line-height: 1.45;
}

.news-overview {
  padding: 72px 0 88px;
  background: #FFFFFF;
}

.overview-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 30px;
}
.overview-heading .section-eyebrow {
  margin-bottom: 0;
}
.overview-heading p {
  margin: 0;
  max-width: 820px;
  color: #52525B;
  font-size: 16px;
  line-height: 1.75;
}

.category-tabs {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 16px;
  margin: 0 -16px 30px;
  background: #FFFFFF;
  border-bottom: 1px solid transparent;
  box-shadow: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.category-tabs.stuck {
  border-bottom-color: #F1F1F3;
  box-shadow: 0 10px 22px rgba(24, 24, 27, 0.06);
}

.category-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  color: #52525B;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.category-tab i {
  font-size: 16px;
  flex: 0 0 auto;
  line-height: 1;
}
.category-tab span {
  display: inline-flex;
  align-items: center;
  line-height: 1.2;
  white-space: nowrap;
}
.category-tab:hover, .category-tab.active {
  border-color: rgba(254, 90, 51, 0.42);
  background: #FFF5F2;
  color: #E04420;
}
.category-tab.active {
  box-shadow: 0 8px 18px rgba(254, 90, 51, 0.12);
}

.news-panel {
  min-height: 420px;
}

.panel-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 20px;
}
.panel-title h3 {
  margin: 0;
  color: #18181B;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.35;
}

.panel-count {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  border: 1px solid #E4E4E7;
  border-radius: 999px;
  background: #FAFAFA;
  color: #71717A;
  font-size: 16px;
  font-weight: 800;
  line-height: 1;
}

.news-year-group + .news-year-group {
  margin-top: 42px;
}

.year-divider {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 12px;
  margin-bottom: 10px;
}
.year-divider::after {
  content: "";
  grid-column: 2;
  grid-row: 1;
  height: 1px;
  background: #E4E4E7;
}
.year-divider strong {
  grid-column: 1;
  grid-row: 1;
  color: #FE5A33;
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
}

.year-count {
  grid-column: 3;
  grid-row: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #A1A1AA;
  font-size: 16px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.news-row {
  display: grid;
  grid-template-columns: 118px 128px minmax(0, 1fr) 104px 38px;
  gap: 18px;
  align-items: center;
  min-height: 118px;
  padding: 18px 0;
  border-bottom: 1px solid #E4E4E7;
  cursor: pointer;
  transition: background 0.18s ease;
}
.news-row:hover {
  background: #FAFAFA;
}
.news-row:last-child {
  border-bottom: 0;
}

.news-row-type {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 10px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
}
.news-row-type i {
  font-size: 16px;
  flex: 0 0 auto;
  line-height: 1;
}
.news-row-type span {
  display: inline-flex;
  align-items: center;
  line-height: 1.2;
  white-space: nowrap;
}
.news-row-type.type-notice {
  background: #FFF5F2;
  color: #E04420;
}
.news-row-type.type-article {
  background: #ECFDF5;
  color: #047857;
}
.news-row-type.type-report {
  background: #F8FAFC;
  color: #475569;
}

.news-row-thumb {
  position: relative;
  width: 100%;
  aspect-ratio: 16/10;
  border-radius: 8px;
  background: #F4F4F5;
  overflow: hidden;
}

.thumb-image {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  transition: transform 0.35s ease;
}

.news-row:hover .thumb-image {
  transform: scale(1.04);
}

.thumb-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #A1A1AA;
}
.thumb-empty i {
  font-size: 24px;
}

.news-row-main {
  min-width: 0;
}
.news-row-main h4 {
  margin: 0;
  color: #18181B;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.45;
  word-break: keep-all;
  overflow-wrap: normal;
  transition: color 0.18s ease;
}
.news-row-main p {
  display: -webkit-box;
  margin: 8px 0 0;
  color: #71717A;
  font-size: 16px;
  line-height: 1.65;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-row:hover .news-row-main h4 {
  color: #E04420;
}

.news-row-date {
  color: #71717A;
  font-size: 16px;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
}

.news-row-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: #A1A1AA;
  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;
}
.news-row-action i {
  font-size: 17px;
}

.news-row:hover .news-row-action {
  background: #FFF5F2;
  color: #E04420;
  transform: translateX(2px);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  color: #A1A1AA;
  text-align: center;
}
.empty-state i {
  margin-bottom: 14px;
  font-size: 42px;
  color: #D4D4D8;
}
.empty-state p {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.news-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 36px;
}

.pagination-btn,
.pagination-page {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  height: 38px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  color: #52525B;
  font-size: 16px;
  font-weight: 800;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}
.pagination-btn:hover:not(:disabled), .pagination-btn.active,
.pagination-page:hover:not(:disabled),
.pagination-page.active {
  border-color: rgba(254, 90, 51, 0.42);
  background: #FFF5F2;
  color: #E04420;
}
.pagination-btn:disabled,
.pagination-page:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

@media (max-width: 1024px) {
  .news-hero-inner {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .news-summary {
    max-width: 520px;
  }
  .news-row {
    grid-template-columns: 108px 112px minmax(0, 1fr) 94px;
  }
  .news-row-action {
    display: none;
  }
}
@media (max-width: 768px) {
  .news-hero {
    min-height: 340px;
  }
  .news-hero-inner {
    padding: 48px 0 44px;
  }
  .news-hero-copy h1 {
    font-size: 34px;
    line-height: 1.18;
  }
  .news-hero-copy p {
    font-size: 16px;
    line-height: 1.68;
  }
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .summary-item {
    min-height: 86px;
    border-right: 0;
  }
  .summary-item:nth-last-child(-n+2) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }
  .summary-item:last-child {
    border-bottom: 0;
  }
  .news-overview {
    padding: 56px 0 68px;
  }
  .category-tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 10px 16px;
    scrollbar-width: none;
  }
  .category-tabs::-webkit-scrollbar {
    display: none;
  }
  .category-tab {
    flex: 0 0 auto;
  }
  .panel-title {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .news-row {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
    align-items: start;
    min-height: 0;
    padding: 18px 0;
  }
  .news-row-type {
    justify-self: start;
  }
  .news-row-thumb {
    order: -1;
    max-width: 420px;
  }
  .news-row-date {
    text-align: left;
  }
}`],
})
export class PageNewsComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public category: string = '';
    public items: any[] = [];
    public loaded: boolean = false;
    public loadError = false;
    public total: number = 0;
    public summary: any = { total: 0, notice: 0, article: 0, report: 0, latest_year: '-' };
    public search: any = { page: 1 };
    public pagenation: any = { end: -1, start: -1 };
    public isTabsStuck = false;

    private scrollContainer: HTMLElement;
    private converter = new showdown.Converter();
    private readonly handleContentScroll = () => this.updateTabsStickiness();

    public copy = {
        heroTitle: {
            ko: '시즌의 소식과 공지',
            en: 'SEASON News and Updates'
        },
        heroDesc: {
            ko: '공지사항, 보도자료, 주요 소식을 최신순으로 정리해 제공합니다.',
            en: 'Notices, articles, and company updates are organized newest first.'
        },
        summaryLabel: {
            ko: '뉴스 요약',
            en: 'News Summary'
        },
        overviewDesc: {
            ko: '주요 공지와 보도자료를 연도별 목록으로 정리해 빠르게 확인할 수 있습니다.',
            en: 'Key notices and articles are organized by year for quick review.'
        },
        allTitle: {
            ko: '전체 뉴스',
            en: 'All News'
        }
    };

    public summaryItems = [
        { key: 'total', label: { ko: '전체 게시글', en: 'Total Posts' } },
        { key: 'notice', label: { ko: '공지사항', en: 'Notices' } },
        { key: 'article', label: { ko: '보도자료', en: 'Articles' } },
        { key: 'latest_year', label: { ko: '최신 등록 연도', en: 'Latest Year' } }
    ];

    public categories: NewsCategory[] = [
        { key: '', label: { ko: '전체', en: 'All' }, icon: 'icon-layout-list' },
        { key: 'notice', label: { ko: '공지사항', en: 'Notice' }, icon: 'icon-megaphone' },
        { key: 'article', label: { ko: '보도자료', en: 'Articles' }, icon: 'icon-newspaper' },
        { key: 'report', label: { ko: '보고서', en: 'Reports' }, icon: 'icon-file-text' }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        this.bindScrollContainer();
        this.updateTabsStickiness();
    }

    public ngOnDestroy() {
        const container = this.getScrollContainer();
        if (container) container.removeEventListener('scroll', this.handleContentScroll);
    }

    public async load(page: number = 1) {
        this.search.page = page;
        this.search.category = this.category;
        this.loaded = false;
        this.loadError = false;
        this.items = [];
        this.total = 0;
        this.pagenation = { end: -1, start: -1 };
        await this.service.render();

        const data = await this.requestNewsData(page);
        if (!data) {
            this.loaded = true;
            this.items = [];
            this.total = 0;
            this.summary = null;
            await this.service.render();
            return;
        }

        const rows = data.rows || [];
        const lastpage = data.lastpage || 0;
        const startpage = Math.floor((page - 1) / 10) * 10 + 1;

        this.items = rows;
        this.total = data.total ?? rows.length;
        this.summary = data.stats || null;
        this.pagenation.start = lastpage > 0 ? startpage : -1;
        this.pagenation.end = lastpage > 0 ? Math.min(lastpage, startpage + 9) : -1;
        this.loaded = true;
        await this.service.render();
        this.updateTabsStickiness();
    }

    private async requestNewsData(page: number) {
        try {
            const result = await wiz.call("search", this.search);
            const data = result?.code === 200 ? result.data : null;
            if (!data || !Array.isArray(data.rows)) throw new Error('Invalid news response');
            return data;
        } catch {
            this.loadError = true;
            return null;
        }
    }

    public async selectCategory(category: string) {
        if (this.category === category) return;
        const shouldResetScroll = this.shouldResetPanelScroll();
        this.category = category;
        await this.load(1);
        setTimeout(() => {
            if (shouldResetScroll) this.scrollToPanelTop();
            this.updateTabsStickiness();
        }, 0);
    }

    public async goPage(page: number) {
        if (page < 1 || page === this.search.page) return;
        await this.load(page);
        setTimeout(() => this.scrollToPanelTop(), 0);
    }

    public newsGroups(): NewsGroup[] {
        const groups: NewsGroup[] = [];
        this.items.forEach(item => {
            const year = this.itemYear(item);
            let group = groups.find(entry => entry.year === year);
            if (!group) {
                group = { year, items: [] };
                groups.push(group);
            }
            group.items.push(item);
        });
        return groups;
    }

    public get pages(): number[] {
        const pages: number[] = [];
        if (this.pagenation.start < 1 || this.pagenation.end < 1) return pages;
        for (let page = this.pagenation.start; page <= this.pagenation.end; page++) pages.push(page);
        return pages;
    }

    public itemTitle(item: any) {
        return this.localize(item?.title);
    }

    public desc(item: any) {
        const markdown = this.localize(item?.content);
        let text = markdown;
        try {
            const html = this.converter.makeHtml(markdown || '');
            if (typeof DOMParser !== 'undefined') {
                text = new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
            } else {
                text = html.replace(/<[^>]*>/g, ' ');
            }
        } catch {
            text = markdown || '';
        }
        text = text.replace(/\s+/g, ' ').trim();
        if (text.length > 148) text = text.substring(0, 145) + '...';
        return text;
    }

    public categoryLabel(key: string) {
        const cat = this.categories.find(item => item.key === key);
        return cat ? this.text(cat.label) : key;
    }

    public categoryIcon(key: string) {
        const cat = this.categories.find(item => item.key === key);
        return cat ? cat.icon : 'icon-newspaper';
    }

    public currentCategoryTitle() {
        if (!this.category) return this.text(this.copy.allTitle);
        return this.categoryLabel(this.category);
    }

    public itemYear(item: any) {
        const created = item?.created || '';
        return created.length >= 4 ? created.substring(0, 4) : '-';
    }

    public itemDate(item: any) {
        const created = item?.created || '';
        if (created.length < 10) return created;
        return created.substring(0, 10).replace(/-/g, '.');
    }

    public statValue(key: string) {
        if (this.loadError || !this.summary) return '-';
        const value = this.summary ? this.summary[key] : undefined;
        if (value === undefined || value === null || value === '') return '0';
        return String(value);
    }

    public totalLabel() {
        if (this.loadError) return '-';
        return `${this.total} ${this.currentLang === 'ko' ? '건' : 'items'}`;
    }

    public text(value: LocalText) {
        if (!value) return '';
        const lang = this.currentLang;
        return value[lang] || value.en || value.ko || '';
    }

    public get currentLang(): 'ko' | 'en' {
        try {
            return this.service.lang.get() === 'ko' ? 'ko' : 'en';
        } catch {
            return 'en';
        }
    }

    private localize(value: any) {
        if (!value) return '';
        if (typeof value === 'string') return value;
        const lang = this.currentLang;
        return value[lang] || value.ko || value.en || '';
    }

    private bindScrollContainer() {
        const container = this.getScrollContainer();
        if (!container) return;
        container.removeEventListener('scroll', this.handleContentScroll);
        container.addEventListener('scroll', this.handleContentScroll, { passive: true });
    }

    private getScrollContainer(): HTMLElement {
        if (this.scrollContainer && document.body.contains(this.scrollContainer)) return this.scrollContainer;
        this.scrollContainer = document.querySelector('.layout-content') as HTMLElement;
        return this.scrollContainer;
    }

    private updateTabsStickiness() {
        const container = this.getScrollContainer();
        const tabs = document.querySelector('wiz-page-news .category-tabs') as HTMLElement;
        if (!container || !tabs) return;

        const containerTop = container.getBoundingClientRect().top;
        const isStuck = tabs.getBoundingClientRect().top <= containerTop + 1 && container.scrollTop > 0;
        if (this.isTabsStuck === isStuck) return;

        this.isTabsStuck = isStuck;
        this.service.render();
    }

    private shouldResetPanelScroll() {
        if (this.isTabsStuck) return true;

        const container = this.getScrollContainer();
        const panel = document.querySelector('wiz-page-news .news-panel') as HTMLElement;
        const tabs = document.querySelector('wiz-page-news .category-tabs') as HTMLElement;
        if (!container || !panel) return false;

        const tabsHeight = tabs ? tabs.offsetHeight : 0;
        return panel.getBoundingClientRect().top < container.getBoundingClientRect().top + tabsHeight;
    }

    private scrollToPanelTop() {
        const container = this.getScrollContainer();
        const panel = document.querySelector('wiz-page-news .news-panel') as HTMLElement;
        const tabs = document.querySelector('wiz-page-news .category-tabs') as HTMLElement;
        if (!container || !panel) return;

        const containerTop = container.getBoundingClientRect().top;
        const panelTop = panel.getBoundingClientRect().top;
        const tabsHeight = tabs ? tabs.offsetHeight : 0;
        const top = container.scrollTop + panelTop - containerTop - tabsHeight - 18;
        container.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    }
}

export default PageNewsComponent;